import DeleteIcon from 'Components/common/assets/svgIcons/DeleteIcon';
import MoveToFolderSvg from 'Components/common/assets/svgIcons/MoveToFolderSvg';
import RenameIcon from 'Components/common/assets/svgIcons/RenameIcon';
import SaveIcon from 'Components/common/assets/svgIcons/SaveIcon';
import { DocHubEntity, Document, Folder } from 'Types/DocumentHubTypes';
import {
  SecondaryColor, primaryColor, primaryFont, wMedium,
} from 'Utils/utilsStyle';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from 'Slice/DocumentHubSlice';
import { actions as flurryActions } from 'Slice/HelperSlice';
import styled from 'styled-components';
import CollaboratorsIcon from 'Components/common/assets/svgIcons/CollaboratorsIcon';
import ManageAccessIcon from 'Components/common/assets/svgIcons/ManageAccessIcon';
import { valueToObject } from 'Utils/UtilityFunctions';
import { selectIsAdmin } from 'Selector/DocumentHubSelector';
import classNames from 'classnames';

const StyleWrapper = styled.div`
&.actions-div {
    display: flex;
    flex-direction: column;
    .action-point {
      display: flex;
      align-items: center;
      font-family: ${primaryFont};
      font-size: 16px;
      font-weight: ${wMedium};
      line-height: 24px;
      letter-spacing: -0.4px;
      color: ${SecondaryColor};
      margin-top: 10px;
      cursor: pointer;
      &:nth-child(1) {
        margin-top: 0px;
      }
      &:hover {
        color: ${primaryColor};
        svg {
          path {
            fill: ${primaryColor};
          }
        }
      }
      svg {
        width: 18px;
        min-width: 18px;
        height: 18px;
        margin-right: 8px;
      }
      &.remove{
        color: #CF1322;
        &:hover {
        color: #CF1322;
        svg {
          path {
            fill: #CF1322;
          }
        }
      }
      }
    }
  }
`;

type PopOverProps = {
  entity: DocHubEntity;
  type: 'folder' | 'document'
  onRename: () => void
};

const DocumentHubPopoverContent = function DocumentHubPopoverContent(props: PopOverProps) {
  const dispatch = useDispatch();
  const {
    entity, type, onRename
  } = props;

  const host = window.location.href;
  const isAdmin = useSelector(selectIsAdmin);

  const { id } = entity;

  const name = type === 'document' ? (entity as Document).fileName + '.' + (entity as Document).extension : (entity as Folder).name;
  const collaboratorsCount = type === 'folder' ? (entity as Folder).collaboratorsCount : 0;

  const handleDelete = () => {
    dispatch(actions.setDeletePopupType(type));
    dispatch(actions.toggleDocumentPopover(id));
    dispatch(actions.setDeleteId(id));
    dispatch(actions.setDeletePopupVisible(true));
    dispatch(flurryActions.callFlurryEvent(valueToObject(`documentHub_${type === 'folder' ? 'folder' : 'file'}_delete_intent_clicked`, 0, {
      user_type: isAdmin ? 'admin' : 'member',
      document_id: id,
      host,
    })));
  };

  const handleDownload = () => {
    dispatch(actions.toggleDocumentPopover(id));
    dispatch(actions.getDocumentDownloadURL({ id }));
  };

  const handleRename = () => {
    onRename();
  };

  const handleCopy = () => {
    dispatch(actions.setFoldersPopupType('copy'));
    dispatch(actions.toggleFoldersPopup(true));
    dispatch(actions.pushFoldersPopupSelectedDocument(id));
  };

  const handleMove = () => {
    dispatch(actions.setFoldersPopupType('move'));
    dispatch(actions.toggleFoldersPopup(true));
    dispatch(actions.pushFoldersPopupSelectedDocument(id));
  };

  const manageAccess = () => {
    dispatch(actions.setCollabPopupType('collaborators'));
    dispatch(actions.setCollabPopupFolderId(id));
    dispatch(actions.toggleCollabPopup(true));
  };

  const handleCollab = () => {
    dispatch(actions.setCollabPopupType('people'));
    dispatch(actions.setCollabPopupFolderId(id));
    dispatch(actions.toggleCollabPopup(true));
  };

  return (
    <StyleWrapper className="actions-div">
      {
        entity.deleteAllowed
          ? (
            <span tabIndex={0} role="button" className="action-point" onClick={handleRename} onKeyDown={handleRename}>
              <RenameIcon color={SecondaryColor} />
              Rename
            </span>
          ) : null
      }
      {type === 'folder' && entity.deleteAllowed ? (
        <>
          <span tabIndex={0} role="button" className="action-point" onClick={handleCollab} onKeyDown={handleCollab}>
            <CollaboratorsIcon color={SecondaryColor} />
            Add Collaborator
          </span>
          <span tabIndex={0} role="button" className={classNames("action-point", { disabled: !collaboratorsCount })} onClick={manageAccess} onKeyDown={manageAccess}>
            <ManageAccessIcon color={SecondaryColor} />
            Manage Access
          </span>
        </>
      ) : null}

      {type === 'document'
        ? (
          <>
            <span tabIndex={0} role="button" className="action-point" onClick={handleDownload} onKeyDown={handleDownload}>
              <SaveIcon color={SecondaryColor} />
              Download
            </span>
            {entity.deleteAllowed
              ? (<><span tabIndex={0} role="button" className="action-point" onClick={handleMove} onKeyDown={handleMove}>
                <MoveToFolderSvg />
                Move
              </span>
                <span tabIndex={0} role="button" className="action-point" onClick={handleCopy} onKeyDown={handleCopy}>
                  <MoveToFolderSvg />
                  Copy
                </span></>) : null}
          </>
        )
        : null}

      {
        entity.deleteAllowed
          ? (
            <span tabIndex={0} role="button" className="action-point remove" onClick={handleDelete} onKeyDown={handleDelete}>
              <DeleteIcon color="#CF1322" />
              Delete
            </span>
          ) : null
      }
    </StyleWrapper>
  );
};

export default DocumentHubPopoverContent;
